function displayImage($previewTemplate, name) {
	var extensionImages = ["jpg", "jpeg", "png"],
		extensionFile = name.split('.').pop(-1)
	;
	if (extensionImages.indexOf(extensionFile) !== -1) {
		var $img = $previewTemplate.find('img[data-dz-picture]');
		var src = Routing.generate('app_serve_document', { 'fileIdentifier' : name});
		$img.attr('src', src).show();
	}
	else if (extensionFile === 'pdf') {
		var $canvas = $previewTemplate.find('[data-dz-pdf-canvas]');
		var $count = $previewTemplate.find('[data-dz-pdf-count]');
		var pdfUrl = Routing.generate('app_serve_document', { 'fileIdentifier': name });
		var pdfDisplayUrl = '/display-documents/' + encodeURIComponent(name);

		// Add pdf-canvas class and data-pdf-url for modal preview (use display route for inline viewing)
		$canvas.addClass('pdf-canvas').attr('data-pdf-url', pdfDisplayUrl).css('cursor', 'pointer');

		pdfjsLib.getDocument(pdfUrl).promise.then(function (pdfDoc) {

			const numPages = pdfDoc.numPages;

			// Afficher le nombre de pages
			if ($count.length > 0) {
				const label = numPages > 1 ? ' pages' : ' page';
				$count.text(numPages + label);
				$count.show();
			}
			var renderTask = null;

			function renderPage(pageNum, scale) {
				if (renderTask) {
					renderTask.cancel();
				}

				pdfDoc.getPage(pageNum).then(function (page) {
					const viewport = page.getViewport({ scale });
					$canvas[0].height = viewport.height;
					$canvas[0].width = viewport.width;

					renderTask = page.render({ canvasContext: $canvas[0].getContext('2d'), viewport });
					$canvas.show();
					return renderTask.promise;

				}).catch(function (error) {
					console.error('Error rendering page:', error);
				});
			}

			renderPage(1, 1);

		}).catch(function (error) {
			console.error('Error loading PDF:', error);
		});
	}
}


function displayState(element, stateFolder, stateGlobalFolder, comment, messageStudent) {
	var $uploadZoneContent = $(element).parent().parent();
	if (undefined !== stateFolder) {
		if (stateFolder === -1) {
			$(element).find('.state.text-warning').show();
		}
		if (stateFolder === 0) {
			$(element).find('.state.text-danger').show();

			if (stateGlobalFolder === 0) {
				$uploadZoneContent.find('.fuc-danger').show();
			}
		}
		if (stateFolder === 1) {
			$(element).find('.state.text-success').show();

			if (stateGlobalFolder === 1) {
				$uploadZoneContent.find('.fuc-success').show();
			}
		}
	} else {
		$(element).find('.state.text-warning').show();
	}

	// Display the admin (general) comment and the student (client) comment,
	// each in their own card, independently of stateFolder.
	if (comment) {
		var formattedComment = comment.replace(/\n/g, '<br>');
		$(element).find('[data-dz-comment]').html(formattedComment);
		$(element).find('[data-dz-comment]').closest('.vuc-comment').show();
		$(element).find('.vuc-comments').show();
	}
	if (messageStudent) {
		var formattedClientComment = messageStudent.replace(/\n/g, '<br>');
		$(element).find('[data-dz-comment-client]').html(formattedClientComment);
		$(element).find('[data-dz-comment-client]').closest('.vuc-comment').show();
		$(element).find('.vuc-comments').show();
	}
}

// Student deletes their own (client) comment from an uploaded document card
$(document).on('click', '[data-dz-comment-client-delete]', function (e) {
	e.preventDefault();

	var $this = $(this),
		docId = $this.attr('data-id');

	if (!docId || !confirm($this.data('confirm-message'))) {
		return;
	}

	$.ajax({
		method: 'POST',
		url: Routing.generate('app_service_VisaData_delete_student_message', { 'id': docId })
	}).done(function () {
		var $card = $this.closest('.vuc-comment'),
			$comments = $card.closest('.vuc-comments');

		$card.hide().find('[data-dz-comment-client]').empty();
		if (!$comments.find('.vuc-comment').filter(function () { return $(this).css('display') !== 'none'; }).length) {
			$comments.hide();
		}

		// Clear the editable comment box too when it is bound to this same document
		$('.visa-comment-card').filter(function () {
			return String($(this).data('doc-id')) === String(docId);
		}).find('textarea').val('');
	}).fail(function () {
		toastr.error($this.data('error-message'));
	});
});

$(function () {
	$('[data-toggle="tooltip"]').tooltip();

	$('.select2-hidden-accessible').select2({
		matcher: customMatcher
	});

	$('.accomodation-slider').owlCarousel({
		loop: 1,
		nav: 1,
		navText: ["<span class='icon icon-arrow-left7 large-icon'></span>", "<span class='icon icon-arrow-right7 large-icon'></span>"],
		dots: 0,
		items: 1,
		//autoplay: 1,
		smartSpeed: 1000,
		responsive: {
			0: {
				items: 1
			}
		}
	});


	Dropzone.autoDiscover = false;

	var uploaderObserver = new IntersectionObserver(function (entries, observer) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				var el = entry.target;
				observer.unobserve(el);
				initUploader($(el), $(el).data('unique'));
			}
		});
	}, { rootMargin: '200px' });

	$('.uploader').filter(function () {
		return !$(this).hasClass('uploader-disabled') || $(this).hasClass('uploader-disabled') && $(this).hasClass('initialize');
	}).each(function () {
		uploaderObserver.observe(this);
	});

	/**
	 * Update icon to uploaded document for visa
	 *
	 * @param element
	 */
	function updateVisaDocumentIcons(element) {
		try {
			const uploadContainer = $(element)?.closest('.documents-upload-area');
			const uploadContainerId = uploadContainer?.attr('id');
			if (uploadContainerId) {
				const menu = $('.visa-documents-menu').find(`[data-target="#${uploadContainerId}"]`);
				const context = menu?.attr('data-context');
				const alias = menu?.attr('data-alias');
				const declarant = menu?.attr('data-declarant');
				if (context && alias) {
					//Get icon from backend
					$.ajax(Routing.generate('app_visa_document_icon', {context, alias, declarant}), {
						method: 'GET',
						success: function (res) {
							if (res && res.icon) {
								menu.find('img')?.attr('src', '/assets/images/' + res.icon);
							}
						}
					})
				}
			}
		} catch (e) {
			console.error(e);
		}
	}
	function initUploader(element, unique) {

		var docList = [];

		var context = element.data('context'), 
			alias = element.data('alias'), 
			id = element.data('extra-id'),
			entity = element.data('entity'),
			declarant = element.data('declarant'),
			source = element.data('source');
		
		var fetchUrl = Routing.generate('app_upload_get_from_context', { 'context' : context, 'coma_aliases' : alias});
		var uploadurl = Routing.generate('app_upload', { 'context' : context, 'alias' : alias });
		var $clickableContent = element.find('.uploader-zone-content');

		var $spinner = $('<div class="uploader-loading-spinner"><i class="fa fa-spinner fa-spin"></i></div>');
		element.find('.form-upload-container').append($spinner);

		$.ajax({
			method: 'GET',
			data: {extraId: id, entity, declarant},
			url: fetchUrl,
		}).done(function (res) {
			$spinner.remove();

			var $dropper = element.find('.dropper');

			if ($dropper[0] && $dropper[0].dropzone) {
				$dropper[0].dropzone.files = [];
				$dropper[0].dropzone.destroy();
				$dropper.removeClass('dropzone dz-started dz-clickable');
			}

			var noExistingFiles = element.data('no-existing-files');

			var dropzoneInstance = $dropper.dropzone({
				acceptedFiles: ".jpg, .png, .doc, .docx, .pdf, .jpeg",
				dictDefaultMessage: "Choose or drop  file from your computer",
				url: uploadurl,
				clickable: $clickableContent[0],
				params: {
					extraId: id,
					entity,
					source,
					declarant
				},
				// createImageThumbnails: false,
				uploadMultiple: false,
				maxFiles: unique ? 1 : 10,
				maxFilesize: 10,
				previewTemplate: element.find('.uploader-uploaded-item').html(),
				previewsContainer: element.find('.preview')[0],
				init: function () {
					this.on("addedfile", function() {
						while (this.files.length > this.options.maxFiles) {
							this.removeFile(this.files[0]);
						}
					});
				},
				success: function (file, res) {
					var $previewTemplate = $(file.previewTemplate);
					if (res.success) {
						updateVisaDocumentIcons(this.element);
						element.trigger('uploader:success', [res]);

						if (element.data('show-upload-toast') && typeof toastr !== 'undefined') {
							var uploadToastMessage = element.data('upload-toast-message');
							if (uploadToastMessage) {
								toastr.options = {
									"closeButton": true,
									"timeOut": "5000",
									"extendedTimeOut": "5000",
								};
								toastr.success(uploadToastMessage);
							}
						}

						// on set l'id pour pouvoir faire la suppression plus tard
						file.id = res.document.id;
						$previewTemplate.find('[data-dz-comment-client-delete]').attr('data-id', res.document.id);
						// CA NE MARCHE PAS ...
						// on change le nom du file de dropzone avec celui généré par le serveur
						file.name = res.document.name;


						if ($previewTemplate.find('a[data-dl-link]')) {
							$previewTemplate.find('a[data-dl-link]').attr('href', res.document.url);
						}

						docList[res.document.id] = {id: res.document.id, name: res.document.name};

						if (unique) {
							$clickableContent.hide()
						}

						if (res.convertTo === 'jpeg') {

							$.ajax({
								method: 'POST',
								url: Routing.generate('app_to_jpeg_convert', { 'documentId': res.document.id }),
								data: {
									filePath: res.document.url
								},
								success: function (response) {
									if (response.success) {
										console.log(response.success);
									}
									if (response.name) {
										displayImage($previewTemplate, response.name);
										$previewTemplate.find('[data-dz-name]').text(response.name);
										$previewTemplate.find('span[data-dz-errormessage]').hide();
										displayState($previewTemplate, -1);
									}
								},
								error: function (error) {
									console.error('Error occurred while converting file to JPEG');
								}
							});

							return;
						}

						$.ajax({
							method: 'POST',
							url: Routing.generate('app_image_to_pdf_convert', { 'documentId': res.document.id }),
							data: {
								filePath: res.document.url
							},
							success: function (response) {
								if (response.success) {
									console.log(response.success);
								}
								if (response.name) {
									displayImage($previewTemplate, response.name);
									$previewTemplate.find('span[data-dz-errormessage]').hide();
									displayState($previewTemplate, -1);
								}
							},
							error: function (error) {
								console.error('Error occurred while converting file to PDF');
							}
						});
					} else {
						displayState($previewTemplate, 0, null, 'server error: ' + res.error);
					}
				},
				error: function (file, response) {
					this.removeFile(file);

					let errorMessage = 'Upload error occurred';
					let errorMessageFr = 'Erreur lors du téléchargement';

					// Get current language from URL
					var currentLanguage = window.location.pathname.split('/')[1];

					// Check if error is due to file size
					if (typeof response === 'string' && response.includes('too big')) {
						errorMessage = `File is too large. Max size: ${this.options.maxFilesize} MB`;
						errorMessageFr = `Fichier trop lourd. Taille max: ${this.options.maxFilesize} Mo`;
					}
					// Check if error is due to invalid file type
					else if (typeof response === 'string' && response.includes('not accepted')) {
						errorMessage = 'Invalid file type';
						errorMessageFr = 'Type de fichier non valide';
					}
					// Check if error is from server response
					else if (response && typeof response === 'object') {
						if (response.error) {
							errorMessage = response.error;
							errorMessageFr = response.error;
						} else if (response.message) {
							errorMessage = response.message;
							errorMessageFr = response.message;
						}
					}
					// Generic string error from Dropzone or server
					else if (typeof response === 'string') {
						errorMessage = response;
						errorMessageFr = response;
					}

					// Truncate message if too long (max 50 characters)
					// if (errorMessage.length > 50) {
						// errorMessage = errorMessage.substring(0, 50) + '...';
					// }
					// if (errorMessageFr.length > 50) {
						// errorMessageFr = errorMessageFr.substring(0, 50) + '...';
					// }

					// Display error message in appropriate language
					toastr.error(currentLanguage === 'fr' ? errorMessageFr : errorMessage, '', {
						timeOut: 0,
						extendedTimeOut: 0,
						closeButton: true
					});
				},
				removedfile: function (file) {

					//validated document cannot be deleted
					if (file.state === 1) {
						var currentLanguage = window.location.pathname.split('/')[1],
							message = 'Un document validé ne peut être supprimé';

						if (currentLanguage === 'en') {
							message = 'A validated document cannot be deleted';
						}

						toastr.error(message, '', {
						timeOut: 0,
						extendedTimeOut: 0,
						closeButton: true
					});
						
						return false;
					}

					if (file.id) {
						const element = this.element;
						var deleteUrl = Routing.generate('app_upload_remove', { 'id' : file.id });;
						$.ajax({
							method: 'DELETE',
							url: deleteUrl,
						}).done(function () {
							delete docList[file.id];
							updateVisaDocumentIcons(element);
						});
					}

					if (unique) {
						$clickableContent.show()
					}

					file.previewElement.remove();

				},

			})[0].dropzone;

			// move the already-uploaded-files preview out of the drag & drop box into
			// the dedicated full-width row above it (visa "Upload the document" panel).
			// Dropzone already holds its own reference to this node (set as
			// previewsContainer above), so relocating it afterwards doesn't break uploads.
			var $duaTop = element.closest('.dua-upload-inner').find('.dua-top').first();
			if ($duaTop.length) {
				element.find('.preview').addClass('pv-doc-files').appendTo($duaTop);
			}

			element.addClass('dropzone') // pour css

			//Ajout de la progress bar
			dropzoneInstance.on("totaluploadprogress", function(progress) {
				element.find('.upload-in-progress').show();
				element.find('.form-upload-container').hide();
				if (progress === 100) {
					setTimeout(() => {
						element.find('.upload-in-progress').hide();
						element.find('.form-upload-container').show();
					}, 2000);
				}
			});

			dropzoneInstance.on('complete', function() {
				element.find('.upload-in-progress').hide();
				element.find('.form-upload-container').show();
			});

			// populate avec les doc déja uploadés :
			if (!noExistingFiles && res.filesUploaded.length) {
				if (unique) {
					$clickableContent.hide()
				}


				$.each(res.filesUploaded, function (key, doc) {


					var file = {
							name: doc.name,
							size: doc.size,
							status: Dropzone.ADDED,
							accepted: true,
							id: doc.id,
							stateFolder: doc.stateFolder,
							isParent: doc.isParent, 
							state: doc.state
						},
						$previewTemplate = $(file.previewTemplate);

					dropzoneInstance.emit("addedfile", file);

					$previewTemplate = $(file.previewTemplate);

					if ($previewTemplate.find('a[data-dl-link]')) {
						$previewTemplate.find('a[data-dl-link]').attr('href', doc.url);
					}

					displayImage($previewTemplate, doc.name);

					dropzoneInstance.emit("complete", file);

					displayState(file.previewTemplate, doc.state, doc.stateFolder, doc.message, doc.messageStudent);

					$(file.previewTemplate).find('[data-dz-comment-client-delete]').attr('data-id', doc.id);

					if (doc.state === 1) {
						$(file.previewTemplate).find('a[data-dz-remove]').hide();
					}

					docList[doc.id] = doc;
				});
			}
		});
	}

	window.initUploader = initUploader;

	//when burger menu is display : scroll top
	$(document).on('shown.bs.collapse', '.header-collapse', function () {
		var $menu = $(this);
		$menu.get(0).scrollIntoView({
			block: 'start',
			behavior: 'smooth'
		});
	})

	// $('#btn-qa').click(function (){
	// 	getListQa();
	// });


	$(window).on('resize', function () {
		resizeIframe();
	});

	$(window).on('load', function () {
		resizeIframe();
	});


});

const getListQa = () => {
	alert('ici');
}

const resizeIframe = () => {
	$('.inline-editing-tinymce').find('img, iframe').each(function () {
		const iframe = $(this);
		const iframeContainer = iframe.closest('.inline-editing-tinymce');
		let iframeContainerWidth = iframeContainer.width();
		const iframeWidth = iframe.width();
		const iframeHeight = iframe.height();

		//the iframe is inside tab
		if (iframeContainerWidth === 0){
			const tabItemContainer = iframe.closest('.tab-item');
			iframeContainerWidth = tabItemContainer.width();

			if (iframe[0].tagName === 'IMG') {
				return;
			}		
		}

		const aspectRatio = iframeHeight / iframeWidth ;
	
		if (iframeContainerWidth <= iframeWidth) {
			iframe.css({
				width: iframeContainerWidth,
				height: (iframeContainerWidth * aspectRatio)+ 'px'
			});
		} else {
			iframe.css({
				width: '',
				height: ''
			});
		};
	});
}

// Custom matcher function to only match results that start with the search term
const customMatcher = (params, data) => {
	if ($.trim(params.term) === '') {
		return data;
	}
	if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) {
		return data;
	}
	return null;
}
window.customMatcher = customMatcher;

window.toggleResourceStatus = function (btn) {
	const $btn = $(btn);
	const slug = $btn.data('ffservice-slug');
	if (!slug) return;

	const url = Routing.generate('app_ffservice_toggle_complete', { slug: slug });

	$btn.prop('disabled', true);
	$.ajax({ method: 'POST', url: url })
		.done(function (res) {
			if (!res || !res.success) {
				toastr.error('Erreur lors de la mise à jour du statut.');
				return;
			}
			const isCompleted = res.state === 'completed';
			$btn.toggleClass('completed', isCompleted).toggleClass('todo', !isCompleted);
			$btn.find('i').attr('class', 'fa ' + (isCompleted ? 'fa-check-circle' : 'fa-circle-o'));
			$btn.find('.ri-status-text').text(
				isCompleted ? $btn.data('label-done') : $btn.data('label-todo')
			);
			const $card = $btn.closest('.status-item-strategic.steps-item');
			const $badge = $card.find('.sis-badge');
			if ($badge.length && $btn.data('badge-done') && $btn.data('badge-todo')) {
				$card.removeClass('en-cours pending action completed')
					.addClass(isCompleted ? 'completed' : 'en-cours');
				$badge.text(isCompleted ? $btn.data('badge-done') : $btn.data('badge-todo'));
			}
			if (typeof window.refreshResourcesProgress === 'function') {
				window.refreshResourcesProgress();
			}
		})
		.fail(function () {
			toastr.error('Erreur réseau.');
		})
		.always(function () {
			$btn.prop('disabled', false);
		});
};

// Video facade: swap the high-res YouTube thumbnail for a live iframe on click,
// instead of always loading a YouTube iframe (which forces YouTube's own low-res preview).
$(document).on('click keydown', '.video-facade', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    e.preventDefault();
    const $facade = $(this);
    const videoSrc = $facade.data('video-src');
    if (!videoSrc || $facade.find('iframe').length) {
        return;
    }
    const separator = videoSrc.indexOf('?') === -1 ? '?' : '&';
    $facade.replaceWith(
        $('<iframe>', {
            src: videoSrc + separator + 'autoplay=1',
            frameborder: '0',
            allow: 'autoplay; fullscreen',
            allowfullscreen: true,
            css: { width: '100%', height: $facade.outerHeight() || '100%' }
        })
    );
});

// PDF Modal functionality
$(function () {
    function ensurePdfModal() {
        if ($('#pdfModal').length === 0) {
            const modalHtml = `
                <div class="modal fade" id="pdfModal" tabindex="-1" role="dialog" aria-labelledby="pdfModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document" style="max-width: 90%; height: 90vh;">
                        <div class="modal-content" style="height: 100%;">
                            <div class="modal-header">
                                <h5 class="modal-title" id="pdfModalLabel">Aperçu du document</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Fermer">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="padding: 0; height: calc(100% - 56px); position: relative;">
                                <div id="pdfModalLoader" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center;">
                                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                                    <p style="margin-top: 10px;">Chargement...</p>
                                </div>
                                <iframe id="pdfModalFrame" style="width: 100%; height: 100%; border: none; display: none;"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $('body').append(modalHtml);

            // Hide loader when iframe is loaded
            $('#pdfModalFrame').on('load', function () {
                $('#pdfModalLoader').hide();
                $(this).show();
            });

            // Clean up when modal is closed
            $('#pdfModal').on('hidden.bs.modal', function () {
                $('#pdfModalFrame').attr('src', '').hide();
                $('#pdfModalLoader').show();
            });
        }
    }

    // Click handler for pdf-canvas (delegated for dynamic elements)
    $(document).on('click', '.pdf-canvas', function () {
        const pdfUrl = $(this).data('pdf-url');
        if (!pdfUrl) return;

        ensurePdfModal();
        $('#pdfModalLoader').show();
        $('#pdfModalFrame').hide().attr('src', pdfUrl);
        $('#pdfModal').modal('show');
    });
});
